"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _has = _interopRequireDefault(require("lodash/has"));

var _pull = _interopRequireDefault(require("lodash/pull"));

var _delay = _interopRequireDefault(require("lodash/delay"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/lib/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/lib/Popover"));

var _popoverModule = _interopRequireDefault(require("./popover.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {}; // Using a wrapper for the full width popover so we can control its positioning (Overlay does it otherwise)


var PopoverWrapper = function PopoverWrapper(props) {
  var popoverPadding = props.popoverPadding,
      popoverArrowOffsetLeft = props.popoverArrowOffsetLeft,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["popoverPadding", "popoverArrowOffsetLeft", "children"]);

  return _react.default.createElement(_Popover.default, _extends({}, otherProps, {
    bsClass: _popoverModule.default.popover,
    arrowOffsetLeft: popoverArrowOffsetLeft,
    style: {
      left: "".concat(popoverPadding, "px"),
      right: "".concat(popoverPadding, "px")
    }
  }), children);
};

PopoverWrapper.displayName = 'nw-popover-wrapper';
PopoverWrapper.propTypes = {
  popoverArrowOffsetLeft: _propTypes.default.number,
  popoverPadding: _propTypes.default.number,
  children: _propTypes.default.node
};
PopoverWrapper.defaultProps = {
  popoverPadding: 18,
  popoverArrowOffsetLeft: 0,
  children: null
};

var Popover =
/*#__PURE__*/
function (_Component) {
  _inherits(Popover, _Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleHoverContentMouseOver", function () {
      _this.hide = noop; // prevent hiding popover when user is hovering over content

      _this.BSOverlayTrigger.show();
    });

    _defineProperty(_assertThisInitialized(_this), "handleHoverContentMouseOut", function () {
      _this.hide = _this.BSOverlayTrigger.hide.bind(_this.BSOverlayTrigger);
      (0, _delay.default)(function () {
        _this.hide();
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnterOverlay", function (e) {
      var onClick = _this.props.onClick;

      _this.setState({
        isPopoverOpen: true
      }); // Note: The overlay could be triggered by events other than "click" (such as "keyDown")


      onClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleExitOverlay", function () {
      _this.setState({
        isPopoverOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTouchEnd", function (triggers) {
      var isPopoverOpen = _this.state.isPopoverOpen;

      if (!triggers.includes('click')) {
        if (isPopoverOpen) {
          _this.BSOverlayTrigger.hide();
        } else {
          _this.BSOverlayTrigger.show();
        }
      }
    });

    _this.state = {
      isPopoverOpen: false
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "show",
    value: function show() {
      this.BSOverlayTrigger.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.BSOverlayTrigger.hide();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          container = _this$props.container,
          fullWidthProps = _this$props.fullWidthProps,
          id = _this$props.id,
          placement = _this$props.placement,
          popoverClassName = _this$props.popoverClassName,
          popoverContent = _this$props.popoverContent,
          rootClose = _this$props.rootClose,
          shouldDelay = _this$props.shouldDelay,
          type = _this$props.type;
      var triggers = typeof type === 'string' ? [type] : _toConsumableArray(type);
      (0, _pull.default)(triggers, 'manual', 'hoverContent'); // TODO: What does `manual` do???
      // Extended "hoverContent" behavior:
      // Allow the popover content to be hoverable,
      // by adding a timeout to the mouseout,
      // and adding a mouseover/out to the content.

      var isHoverContentTrigger = (0, _includes.default)(type, 'hoverContent');
      var onMouseOut = isHoverContentTrigger ? this.handleHoverContentMouseOut : null;
      var onMouseOver = isHoverContentTrigger ? this.handleHoverContentMouseOver : null;

      if (isHoverContentTrigger && !(0, _has.default)(triggers, 'hover')) {
        triggers.push('hover');
      }

      var popoverProps = {
        id: id,
        // `role` should be paired with `aria-describedby`
        role: 'tooltip',
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        bsClass: _popoverModule.default.popover,
        className: (0, _classnames.default)(popoverClassName, {
          'full-width': fullWidthProps
        })
      };
      var overlay = fullWidthProps ? _react.default.createElement(PopoverWrapper, _extends({}, popoverProps, fullWidthProps), popoverContent) : _react.default.createElement(_Popover.default, popoverProps, popoverContent);
      return _react.default.createElement(_OverlayTrigger.default, {
        ref: function ref(BootStrapOverlayTrigger) {
          _this2.BSOverlayTrigger = BootStrapOverlayTrigger;
        },
        container: container,
        containerPadding: 10,
        delay: shouldDelay ? 1500 : null,
        overlay: overlay,
        placement: placement,
        rootClose: rootClose,
        trigger: triggers,
        onEnter: this.handleEnterOverlay,
        onExit: this.handleExitOverlay
      }, _react.default.createElement("span", {
        // `aria-describedby` should be paired with `role=tooltip`
        "aria-describedby": id,
        className: (0, _classnames.default)([className, _popoverModule.default['popover-overlay-trigger']]) // `onTouchEnd` for touch device accessibility
        ,
        onTouchEnd: this.handleOnTouchEnd.bind(this, triggers)
      }, children));
    }
  }]);

  return Popover;
}(_react.Component);

exports.default = Popover;
Popover.displayName = 'nw-popover';
Popover.propTypes = {
  /**
   * Recommended; otherwise the tooltip may not be usable
   */
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  /**
   * An DOM element to which to append the overlay
   */
  container: _propTypes.default.node,

  /**
   * If `fullWidthProps` is truthy, then overlay will be full width
   */
  fullWidthProps: _propTypes.default.shape({
    popoverPadding: _propTypes.default.number,
    popoverArrowOffsetLeft: _propTypes.default.number
  }),

  /**
   * An HTML id attribute. Highly recommended to define for accessibility.
   */
  id: _propTypes.default.string,

  /**
   * Callback function whenever the overlay is shown
   */
  onClick: _propTypes.default.func,

  /**
   * Direction the popover is positioned towards.
   */
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
  popoverClassName: _propTypes.default.string,
  popoverContent: _propTypes.default.node,

  /**
   * Whether clicking on the `root` closes the overlay
   */
  rootClose: _propTypes.default.bool,

  /* Whether the overlay is shown after a certain delay
   * Generally used to give users more time to hover over the AdvertiserDisclosure.
   */
  shouldDelay: _propTypes.default.bool,

  /**
   * How the overlay should be triggered
   */
  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['manual', 'click', 'hover', 'focus', 'hoverContent']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['click', 'hover', 'focus', 'hoverContent']))])
};
Popover.defaultProps = {
  children: null,
  className: '',
  container: null,
  fullWidthProps: null,
  id: '',
  onClick: function onClick() {},
  placement: 'bottom',
  popoverClassName: '',
  popoverContent: null,
  rootClose: false,
  shouldDelay: false,
  type: ['hoverContent', 'click']
};